// 为了降低首页首屏依赖的额外路由分包加载，优先使用同步加载；
// 但本文件也会被 Node 脚本(require)引用，Node 无法解析 .vue 文件，
// 因此在非浏览器环境降级为动态 import，避免构建前置脚本报错。
let IndexView;
if (typeof window !== 'undefined') {
  try {
    // 仅在浏览器环境下同步引入，减少首页额外 chunk 请求
    IndexView = require('../views/Index.vue').default;
  } catch (e) {
    // 兜底：如果同步引入失败，则仍回退为按需加载
    IndexView = null;
  }
}

module.exports = [
  {
    path: '/',
    name: 'Index',
    component: IndexView || (() => import('../views/Index.vue')),
    priority: 1,
    changefreq: 'daily',
  },
  {
    path: '/index',
    name: 'IndexPage',
    component: IndexView || (() => import('../views/Index.vue')),
    priority: 1,
    changefreq: 'daily',
  },
  {
    path: '/sale',
    name: 'Sale',
    component: () => import('../views/SalePage.vue'),
    priority: 1,
    changefreq: 'daily',
  },
  {
    path: '/newHome',
    name: 'NewHome',
    component: () => import('../views/SalePage.vue'),
    priority: 1,
    changefreq: 'daily',
  },
  {
    path: '/book',
    name: 'Book',
    component: () => import('../views/BookPage.vue'),

    changefreq: 'monthly',
  },
  // note: 已经废弃
  // {
  //   path: '/about',
  //   name: 'About',
  //   component: () => import('../views/AboutPage.vue'),
  //   changefreq: 'monthly',
  // },
  {
    path: '/buying',
    name: 'Buying',
    component: () => import('../views/BuyingPage.vue'),
    changefreq: 'monthly',
  },
  {
    path: '/service',
    name: 'Service',
    component: () => import('../views/ServicePage.vue'),
    changefreq: 'monthly',
  },
  {
    path: '/join-us',
    name: 'JoinUs',
    component: () => import('../views/JoinUsPage.vue'),
    changefreq: 'monthly',
  },
  {
    path: '/why',
    name: 'Why',
    component: () => import('../views/WhyPage.vue'),
    changefreq: 'monthly',
  },
  {
    path: '/management',
    name: 'ManagementPage',
    component: () => import('../views/ManagementPage.vue'),
    changefreq: 'monthly',
  },
  {
    path: '/managementList',
    name: 'ManagementListPage',
    component: () => import('../views/ManagementListPage.vue'),
    priority: 1,
    changefreq: 'daily',
    disablePrerender: true,
  },
  {
    path: '/managementDetail',
    name: 'ManagementDetailPage',
    component: () => import('../views/ManagementDetailPage.vue'),
    priority: 1,
    changefreq: 'daily',
    isDynamicPage: true,
  },
  {
    path: '/CanDo',
    name: 'CanDoPage',
    component: () => import('../views/CanDoPage.vue'),
    changefreq: 'monthly',
  },
  // {
  //   path: '/rentList',
  //   name: 'RentList',
  //   component: () => import('../views/RentListPage.vue'),

  // },
  // {
  //   path: '/otherService',
  //   name: 'otherService',
  //   component: () => import('../views/OtherServicePage.vue'),
  //   changefreq: 'monthly',
  // },
  // {
  //   path: '/parkingSpace',
  //   name: 'parkingSpace',
  //   component: () => import('../views/ParkingSpacePage.vue'),
  //   changefreq: 'monthly',
  // },
  {
    path: '/letting',
    name: 'letting',
    component: () => import('../views/LettingPage.vue'),

    priority: 1,
    changefreq: 'daily',
  },

  {
    path: '/lettingDetail',
    name: 'lettingDetail',
    component: () => import('../views/LettingDetailPage.vue'),
    isDynamicPage: true,
    priority: 1,
  },
  {
    path: '/applicationForm',
    name: 'applicationForm',
    component: () => import('../views/ApplicationForm.vue'),
    disablePrerender: true,
    changefreq: 'monthly',
  },
  {
    path: '/form/property-purchase-intent',
    name: 'PropertyPurchaseIntent',
    component: () => import('../views/PropertyPurchaseIntent.vue'),
    disablePrerender: true,
    changefreq: 'monthly',
  },
  {
    path: '/houseDetail',
    name: 'houseDetail',
    component: () => import('../views/SaleDetailPage.vue'),
    isDynamicPage: true,
    priority: 1,
  },
  {
    path: '/privacy-policy',
    name: 'privacyPolicy',
    component: () => import('../views/PrivacyPolicyPageV1.vue'),
    changefreq: 'monthly',
  },
  {
    path: '/result',
    name: 'result',
    component: () => import('../views/MessagePage.vue'),
    changefreq: 'monthly',
  },
  {
    path: '/form-rental-requirements',
    name: 'FormRentalRequirements',
    component: () => import('../views/FormRentalRequirementsPage.vue'),
    changefreq: 'monthly',
    disablePrerender: true,
  },
  {
    path: '/article',
    name: 'Article',
    component: () => import('../views/ArticlePage.vue'),
    changefreq: 'monthly',
  },
  {
    path: '/form/201',
    name: 'FormAuthPage',
    component: () => import('../views/FormAuthPage.vue'),
    changefreq: 'monthly',
    disablePrerender: true,
  },
  {
    path: '*',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue'),
    disablePrerender: true,
  },
]
